import React, { useState } from 'react';
import Countable from './Countable'
import { Getintouch } from '../Home/Getintouch'

function Sportsbook() {

  const benefits = [
    {
      id: 'item1',
      title: 'Flexible Product Personalisation',
      img: 'https://everymatrix.com/wp-content/uploads/2024/11/Frame-165.png',
      content: (
        <>
          Achieve market differentiation and showcase your unique brand via responsive,{' '}
          <b>widget-based and highly configurable front-end solutions</b>.
        </>
      )
    },
    {
      id: 'item2',
      title: 'High Market Availability and Profitability',
      img: 'https://everymatrix.com/wp-content/uploads/2024/11/Frame-162.png',
      content: (
        <>
          Grow your business through <b>a unique sports aggregation technology</b> that enables simultaneous usage of multiple data feeds. Improve coverage of local events and gain higher profit margins.
        </>
      )
    },
    {
      id: 'item3',
      title: 'Bet Builder for Higher Margin',
      img: 'https://everymatrix.com/wp-content/uploads/2024/11/Frame-163.png',
      content: (
        <>
          Players can <b>combine markets and selections with the OddsMatrix Bet Builder</b> available across multiple sports and esports disciplines.
        </>
      )
    },
    {
      id: 'item4',
      title: 'Engaging Bonus Campaigns',
      img: 'https://everymatrix.com/wp-content/uploads/2022/07/Frame-128-4.png',
      content: (
        <>
          Get your punters in the game with BonusEngine, creating <b>engaging acquisition and retention campaigns</b> and joint bonuses for sports and casino cross-sell.
        </>
      )
    },
    {
      id: 'item5',
      title: 'Improved Day-to-day Operations',
      img: 'https://everymatrix.com/wp-content/uploads/2022/07/Frame-128-3.png',
      content: (
        <>
          <b>Increase performance and streamline operations</b> with advanced tools for Trading, Risk Management, Settlement, Audit and Reporting.
        </>
      )
    }
  ];
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (id) => {
    setActiveKey(prevKey => (prevKey === id ? null : id));
  };
  return (
    <>
      <nav className="product-submenu blue_nav">
        <ul>
          <li>
            <a href="/fantasy-betting">Overview</a>
          </li>
          <li className='active'>
            <a href="/fantasy-betting/sportsbook">Sportsbook</a>
          </li>
          <li>
            <a href="/fantasy-betting/omnichannel/">Omnichannel</a>
          </li>
          <li>
            <a href="/fantasy-betting/esports-services/">Esports Services</a>
          </li>
          <li>
            <a href="/" target="_blank">Data Feeds</a>
          </li>
        </ul>
      </nav>
      <section className="">
        <div className="container container_custom">
          <div className="row g-md-5 g-4 justify-content-between align-items-center">
            <div className="col-md-5">
              <h1 className="section-title heading_left pt-5">One Sportsbook, <br />Unlimited Performance</h1>
              <div className="description"><p>A modular and agile sportsbook platform offering the best-in-industry sports and esports events coverage. OddsMatrix is built on a new tech stack that ensures high productivity, stability, and scalability.</p>
              </div>
              <div className="btns pt-5">
                <a href="/connect" className="btn btn_blue">Contact us</a>
              </div>
            </div>
            <div className="col-md-6">
              <img className='w-100' src="https://everymatrix.com/wp-content/uploads/2024/11/Sportbook-hero-header-section-1-1.png" />
            </div>
          </div>
          <div className='simple-intro explore_bottom'>
            <a href="#explore" className="explore"></a>
          </div>
        </div>
      </section>
      <Countable />

      <div className="benefits sec-padd-t">
        <div className="container">
          <div className="row mb-4">
            <div className="col-md-8 mx-auto text-center">
              <h2 className="section-title">
                <b>One Sportsbook,</b> Unlimited Benefits
              </h2>
              <p>
                Take complete control of your sportsbook. OddsMatrix offers a highly
                customisable front-end powered by a full-scale back-office for fast
                and precise operational management.
              </p>
            </div>
          </div>
          <div className='row pt-5 m-hide'>
            <div className='col-md-4'>
              <ul className="nav nav-tabs justify-content-center mb-4" id="benefitsTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="tab1-tab" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab" aria-controls="tab1" aria-selected="true">
                    <span>01.</span> Flexible Product Personalisation
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="tab2-tab" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab" aria-controls="tab2" aria-selected="false">
                    <span>02.</span> High Market Availability and Profitability
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="tab3-tab" data-bs-toggle="tab" data-bs-target="#tab3" type="button" role="tab" aria-controls="tab3" aria-selected="false">
                    <span>03.</span> Bet Builder for Higher Margin
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="tab4-tab" data-bs-toggle="tab" data-bs-target="#tab4" type="button" role="tab" aria-controls="tab4" aria-selected="false">
                    <span>04.</span> Engaging Bonus Campaigns
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="tab5-tab" data-bs-toggle="tab" data-bs-target="#tab5" type="button" role="tab" aria-controls="tab5" aria-selected="false">
                    <span>05.</span> Improved Day-to-day Operations
                  </button>
                </li>
              </ul>
            </div>
            <div className='col-md-8'>
              <div className="tab-content" id="benefitsTabContent">
                <div className="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                  <div className="text-center">
                    <img src="https://everymatrix.com/wp-content/uploads/2024/11/Frame-165.png" className="img-fluid mb-3" alt="Flexible Product Personalisation" />
                    <p>Achieve market differentiation and showcase your unique brand via responsive, <b>widget-based and highly configurable front-end solutions</b>.</p>
                  </div>
                </div>

                <div className="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                  <div className="text-center">
                    <img src="https://everymatrix.com/wp-content/uploads/2024/11/Frame-162.png" className="img-fluid mb-3" alt="High Market Availability and Profitability" />
                    <p>Grow your business through <b>a unique sports aggregation technology</b> that enables simultaneous usage of multiple data feeds. Improve coverage of local events and gain higher profit margins.</p>
                  </div>
                </div>

                <div className="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                  <div className="text-center">
                    <img src="https://everymatrix.com/wp-content/uploads/2024/11/Frame-163.png" className="img-fluid mb-3" alt="Bet Builder for Higher Margin" />
                    <p>Players can <b>combine markets and selections with the OddsMatrix Bet Builder</b> available across multiple sports and esports disciplines.</p>
                  </div>
                </div>

                <div className="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                  <div className="text-center">
                    <img src="https://everymatrix.com/wp-content/uploads/2022/07/Frame-128-4.png" className="img-fluid mb-3" alt="Engaging Bonus Campaigns" />
                    <p>Get your punters in the game with BonusEngine, creating <b>engaging acquisition and retention campaigns</b> and joint bonuses for sports and casino cross-sell.</p>
                  </div>
                </div>

                <div className="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
                  <div className="text-center">
                    <img src="https://everymatrix.com/wp-content/uploads/2022/07/Frame-128-3.png" className="img-fluid mb-3" alt="Improved Day-to-day Operations" />
                    <p><b>Increase performance and streamline operations</b> with advanced tools for Trading, Risk Management, Settlement, Audit and Reporting.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='m-show'>
          <div className="accordion" id="benefitsAccordion">
        {benefits.map((item, index) => (
          <div className="accordion-item" key={item.id}>
            <h2 className="accordion-header" id={`heading-${item.id}`}>
              <button
                className={`accordion-button ${activeKey === item.id ? '' : 'collapsed'}`}
                type="button"
                onClick={() => toggleAccordion(item.id)}
                aria-expanded={activeKey === item.id}
                aria-controls={`collapse-${item.id}`}
              >
                <span className="me-2">{`0${index + 1}.`}</span> {item.title}
              </button>
            </h2>
            <div
              id={`collapse-${item.id}`}
              className={`accordion-collapse collapse ${activeKey === item.id ? 'show' : ''}`}
              aria-labelledby={`heading-${item.id}`}
              data-bs-parent="#benefitsAccordion"
            >
              <div className="accordion-body text-center">
                <img src={item.img} className="img-fluid mb-3" alt={item.title} />
                <p>{item.content}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
          </div>
        </div>
      </div>

      <section className="player-benefits bg-light sec-padd  box-full">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row justify-content-between d-flex align-items-center">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Player Benefits</h3>
                      <div className="description   ">
                        <ul>
                          <li>Competitive live betting coverage, including market-specific events</li>
                          <li>Premium and unique local content</li>
                          <li>Massive selection of betting markets</li>
                          <li>Multiple Video Streaming partners integrated</li>
                          <li>Easy access to live, popular and favourite events</li>
                          <li>Pre-live and live Bet Builder available across 10 traditional sports</li>
                          <li>Early cash-out available for singles and multiples across all sports and markets</li>
                          <li>Extensive language coverage</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2022/07/Sportbook-Player-benefits-section-2-1.png" alt="Player Benefits" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="operator-benefits box-full sec-padd">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row d-flex justify-content-between align-items-center">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Operator Benefits</h3>
                      <div className="description">
                        <ul>
                          <li>Empowering Odds Management tools from sport to market level</li>
                          <li>Modern API-based front-end technologies for building truly unique betting websites</li>
                          <li>Refined architectural model that makes introducing new features slick and cost-efficient</li>
                          <li>High fault tolerance, scalability, and rapid addition of extra capacity to support your brand growth</li>
                          <li>High market uptime on live events, with configurable bet suspension times per brand</li>
                          <li>Lightning-fast Automatic Settlement Engine for both pre-live and live bets</li>
                          <li>Manual bet acceptance with configurable limits for your most valuable players</li>
                          <li>Full-fledged back-office providing easy management of the sportsbook offering</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2022/07/Sportsbook-Operator-benefits-section-2-1.png" alt="Operator Benefits" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="campaigns box-full bg-light sec-padd">
        <div className="container">
          <div className="row">
            <div className="col box">
              <div className="inner">
                <div className="inner-content">
                  <div className="row justify-content-between d-flex align-items-center">
                    <div className="col-lg-5">
                      <h3 className="section-title heading_left">Get your players in the game with engaging bonus campaigns</h3>
                      <div className="description">
                        <p>Our clients are leveraging BonusEngine with the OddsMatrix Sportsbook to create rewarding player journeys, extended player sessions, increased reactivation, stronger retention and reduced bonusing costs.</p>
                        <ul>
                          <li>Free Bets, Odds Boost, Stake Back, Risk-free Bets, Cash Bonus, and more</li>
                          <li>Multi-level Wagering bonuses with different rewards per level</li>
                          <li>Fully automated Cash Back based on the player’s losses</li>
                          <li>Sports Tournaments</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 ml-auto d-flex align-items-center">
                      <img src="https://everymatrix.com/wp-content/uploads/2022/07/bonus-campaigns-section-2.png" alt="Get your players in the game with engaging bonus campaigns" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Getintouch/>
    </>
  )
}

export default Sportsbook